import config from "../config";
import {dictionary} from "../constants"
import {Util} from "baziigram"

export default client => {
    function call() {
        return client
            .get(config.app.service.apiUrls.GetGameCategories)
            .then(resp => {
                if (resp.status && (resp.status === 200 || resp.status === 204))
                    return resp.data;

                throw new Error(resp.message || dictionary.serverError[Util.getLanguage()]);
            })
    }

    return call;
};
